import * as types from './constants';

const initialState = {
  // Hash map that stores whether each node is expanded/collapsed.
  expandedNodesById: {},

  // If non-null, denotes that we are adding a new category to this category ID.
  addingToId: null
};
const reducer = (state = initialState, action) => {
  switch (action.type) {

    case types.TOGGLE_CATEGORY_NODE:
      return {
        ...state,
        expandedNodesById: {
          ...state.expandedNodesById,
          [action.id]: !state.expandedNodesById[action.id]
        }
      };

    case types.SHOW_ADD:
      return {
        ...state,
        addingToId: action.id
      };

    case types.HIDE_ADD:
      return {
        ...state,
        addingToId: null
      };

    default: return state;
  }
};

export default reducer;
